import React from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import t from 'react-translate';
import { RootState } from 'redux/schemas';
import NvIcon from 'shared/components/nv-icon';
import NvTooltip from 'shared/components/nv-tooltip';
import NvStackedTab from 'shared/components/nv-stacked-tab';
import CommunicationCreateNewDropdown from 'communications/course_communications/components/communication-create-new-dropdown';
import { ActivityType } from 'redux/schemas/models/activity';
import { ComponentKeyPluralized } from 'redux/schemas/models/lecture-component';
import { isActivityExpandedInAutomatedCommunications } from 'redux/selectors/course-communications';
import CommunicationItem from 'communications/course_communications/components/communication-item/communication-item';

const AiRolePlayTimelineLectureComponent = (props) => {
  const { aiRolePlayId } = props || {};
  const aiRolePlayActivity = useSelector((state: RootState) => state.models.aiRolePlays[aiRolePlayId]);
  const isExpanded = useSelector<RootState, boolean>((state) => isActivityExpandedInAutomatedCommunications(state, ComponentKeyPluralized.AI_ROLE_PLAY, aiRolePlayId));

  return (
    <React.Fragment>
      <div className={`lecture-component-row ${isExpanded && aiRolePlayActivity?.communicationsCount > 0 && 'expanded-box'}`}>
        <NvIcon icon='role-play' size='smallest' />
        <div className='description'>{aiRolePlayActivity?.title}</div>
        {aiRolePlayActivity?.hasStructuralIssues && (
        <div className='text-danger spacing'>
          <NvIcon icon='warning' size='xss-smallest' />
        </div>
        )}
        {aiRolePlayActivity?.hardDeadline && (
        <NvTooltip text={t.TIMELINE.HARD_DEADLINE()} placement='top'>
          <div className='spacing'>
            <NvIcon icon='harddeadline' size='smallest' />
          </div>
        </NvTooltip>
        )}
        <div className='date'>
          {aiRolePlayActivity?.expirationDate && t.LECTURE_PAGES.COMPONENTS.DUE_DATE.STUDENT_VIEW(moment(aiRolePlayActivity.expirationDate).format('LLL'))}
        </div>
        <div className=''>
          <CommunicationCreateNewDropdown activityType={ActivityType.AI_ROLE_PLAY} activityId={aiRolePlayId} />
        </div>
        { aiRolePlayActivity?.communicationsCount > 0 && (
        <NvStackedTab
          count={aiRolePlayActivity.communicationsCount}
          hasError={props.hasCommunicationError}
          isExpanded={isExpanded}
          errorMessage={t.COURSE_COMMUNICATIONS.WARNINGS.ACTIVITY_COMMUNICATION()}
          onClick={() => props.setExpanded({
            type: ComponentKeyPluralized.AI_ROLE_PLAY,
            id: aiRolePlayId,
            isExpanded: !isExpanded,
          })}
        />
        )}
      </div>
      {
        // Communications
        isExpanded && aiRolePlayActivity?.communications && aiRolePlayActivity.communications.map(communicationId => (
          <CommunicationItem key={communicationId.toString()} communicationId={communicationId} />
        ))
      }
    </React.Fragment>
  );
};

export default AiRolePlayTimelineLectureComponent;
